import { FC, useEffect } from 'react';
import { XMarkIcon as CloseIcon } from '@heroicons/react/24/solid';
import ReactModal, { Props as ReactModalProps } from 'react-modal';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
//import useScrollBlock from 'helpers/hooks/useScrollBlock';
import { desktop } from 'helpers/utils/screensizes';

export interface ModalProps extends ReactModalProps {
  closeButton?: boolean;
  maxWidth?: string;
}

const Modal: FC<ModalProps> = ({ children, style, preventScroll, closeButton, className = '', maxWidth = '800px', ...props }) => {
  const [isDesktopSize] = useMediaQuery(desktop);

  //const { blockScroll } = useScrollBlock();

  const modalStyle: ReactModalProps['style'] = {
    overlay: {
      zIndex: 51,
      backgroundColor: 'rgba(127 ,127, 127, .3)',
      ...style?.overlay,
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      maxWidth: isDesktopSize ? maxWidth : '100%',
      position: 'relative',
      padding: 0,
      outline: 'none',
      ...style?.content,
    },
  };

  useEffect(() => {
    if (preventScroll) document.body.style.overflow = props.isOpen ? 'hidden' : 'auto';
  }, [props.isOpen, preventScroll]);
  /*
  useEffect(() => {
    blockScroll(props.isOpen);
  }, [props.isOpen, blockScroll]);*/

  return (
    <ReactModal
      {...props}
      ariaHideApp={false}
      style={modalStyle}
      preventScroll={preventScroll}
      className={`${className} relative overflow-hidden rounded-lg bg-white`}
      parentSelector={() => document.getElementById('react-modal-custom-portal') ?? document.body}
    >
      {closeButton && (
        <button onClick={props.onRequestClose} className="absolute right-20 top-20 focus:ring-1">
          <CloseIcon className="size-24 text-gray-600" />
        </button>
      )}
      {children}
    </ReactModal>
  );
};

export default Modal;
